module.exports = __webpack_public_path__ + "h5/img/correct-icon.ae4abd1e.png";